import { useEffect, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import { Download, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import useDialogBehavior from '../../hooks/useDialogBehavior'
import '../../css/PdfPreviewModal.css'

const PdfPreviewModal = ({ pdfBytes, onDownload, onClose }) => {
	const { t } = useTranslation('finish')
	const dialogRef = useDialogBehavior(onClose)
	const [keepData, setKeepData] = useState(false)
	const pdfUrl = useMemo(() => {
		const blob = new Blob([pdfBytes], { type: 'application/pdf' })
		return `${URL.createObjectURL(blob)}#toolbar=0&navpanes=0`
	}, [pdfBytes])

	useEffect(() => () => URL.revokeObjectURL(pdfUrl.split('#')[0]), [pdfUrl])

	return createPortal(
		<div className='pdf-preview-overlay' onClick={onClose}>
			<div
				className='pdf-preview-modal'
				onClick={e => e.stopPropagation()}
				ref={dialogRef}
				role='dialog'
				aria-modal='true'
				aria-labelledby='pdf-preview-title'
			>
				<div className='pdf-preview-header'>
					<h3 id='pdf-preview-title'>{t('previewTitle')}</h3>
					<button
						type='button'
						className='pdf-preview-close'
						onClick={onClose}
						aria-label={t('previewCloseAriaLabel')}
					>
						<X size={20} />
					</button>
				</div>

				<iframe className='pdf-preview-frame' src={pdfUrl} title={t('previewTitle')} />

				<label className='pdf-preview-keep'>
					<input type='checkbox' checked={keepData} onChange={e => setKeepData(e.target.checked)} />
					{t('previewKeepData')}
				</label>

				<div className='pdf-preview-actions'>
					<button type='button' className='btn-secondary-action' onClick={onClose}>
						{t('previewBackButton')}
					</button>
					<button
						type='button'
						className='btn-primary-action'
						onClick={() => onDownload({ keepData })}
					>
						<Download size={16} style={{ marginRight: '6px', verticalAlign: '-3px' }} />
						{t('previewDownloadButton')}
					</button>
				</div>
			</div>
		</div>,
		document.body
	)
}

export default PdfPreviewModal
